var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.396,
    height: 82.796,
    viewBox: "0 0 120.396 82.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrowCircleLeft",
    transform: "translate(128.675 91.071) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1 -0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(71.675 8.675)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 82.7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 38,
    height: 62.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(46.675 8.675)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 61,
    height: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(50.675 71.375)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 59,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M4,45.4c0,41.459,18.525,41.4,41.4,41.4A41.4,41.4,0,1,0,45.4,4C22.525,4,4,3.937,4,45.4ZM53.1,30.121,64.935,42.54a2.5,2.5,0,0,1,.414.621,2.392,2.392,0,0,1,.414.662,3.958,3.958,0,0,1,0,3.146,4.273,4.273,0,0,1-.869,1.366L52.475,60.754A4.157,4.157,0,1,1,46.6,54.876l5.381-5.34H28.838a4.14,4.14,0,1,1,0-8.279h23.43l-5.175-5.423a4.143,4.143,0,1,1,6-5.713Z",
    transform: "translate(4.279 4.279)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/arrowCircleLeft.f3bdd133e0b9078d0e5f553775a43ac7.svg";
export { ForwardRef as ReactComponent };